export function renderDateFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  onChange,
  toLowerCase
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  onChange: string
  toLowerCase: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <DatePicker
${indent}          value={formField.value}
${indent}          onChange={${onChange}}
${indent}          disabled={isPending}
${indent}          placeholder="Select ${toLowerCase}"
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
